import * as React from 'react';
export const verveSvg = React.forwardRef(function verveSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#ED342B',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.96 21.327A213.88 213.88 0 0 1 10.287 7H5.3a170.195 170.195 0 0 0 8.707 20h3.958a172.347 172.347 0 0 0 8.72-20h-5.013s-2.44 6.913-5.712 14.327Z',
      fill: '#FEFEFE',
    }),
  );
});
verveSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var verve = {
  category: 'brand',
  colorable: false,
  name: 'verve',
  svg: verveSvg,
};
